// types.ts
Object.defineProperties(Symbol, {
  justusValidator: { value: Symbol.for("justus.Validator") },
  justusRestValidator: { value: Symbol.for("justus.restValidator") },
  justusAdditionalValidator: { value: Symbol.for("justus.additionalValidator") }
});
function makeValidatorFactory(validator, factory) {
  return Object.assign(factory, {
    optional: validator.optional,
    defaultValue: validator.defaultValue,
    validate: validator.validate.bind(validator),
    [Symbol.iterator]: validator[Symbol.iterator].bind(validator),
    [Symbol.justusValidator]: validator
  });
}
var AbstractValidator = class {
  [Symbol.justusValidator] = this;
  optional = false;
  defaultValue = void 0;
  /** Allow any `Validator` to be used as a rest parameter in `Tuple`s */
  *[Symbol.iterator]() {
    yield { [Symbol.justusRestValidator]: this };
  }
};
export {
  AbstractValidator,
  makeValidatorFactory
};
//# sourceMappingURL=types.mjs.map
